import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import booksSvc from '../../util/BooksSvc/BooksSvc';
import unpaidPurchaseOrdersDialogTemplate from './UnpaidPurchaseOrdersDialog.template.html';

export default angular
  .module('books.dialogs.UnpaidPurchaseOrdersDialog', [
    'ui.bootstrap',
    csmCommonWeb,
    booksSvc
  ])
  .service('UnpaidPurchaseOrdersDialog', UnpaidPurchaseOrdersDialogService)
  .name;

/*****************************************************************************
 * Service: UnpaidPurchaseOrdersDialog
 *
 * Service to display dialog with a list of unfulfilled purchase orders with
 * the option to close them.
 *****************************************************************************/
/* @ngInject */
function UnpaidPurchaseOrdersDialogService(
  $uibModal,
  $q,
  BooksSvc,
  BusyScreen,
  uiGridConstants
) {
  /***************************************************************************
   * show */
  /**
   * Show the dialog with unfulfilled purchase orders found by the item detail
   * IDs if available
   *
   * @param   date            Date to be used should the items be closed.
   * @param   itemsIDs        Array of purchase order item IDs
   * @return                  Promise to listen to
   ***************************************************************************/
  this.show = function (date, itemsIDs) {
    var defer = $q.defer();

    /*--------------------------------------------------------*/
    /* get open POs if any available orders and display modal */
    /*--------------------------------------------------------*/
    BooksSvc.getOpenPOsFromDetail(itemsIDs).then(function (resp) {
      if (resp.data.length) {
        $uibModal
          .open({
            animation: true,
            backdrop: 'static',
            size: 'md',
            template: unpaidPurchaseOrdersDialogTemplate,
            controller: function (
              $scope,
              $uibModalInstance,
              BooksSvc,
              uiGridConstants
            ) {
              $scope.upoGrid = {
                enableColumnMenus: false,
                enableCellEdit: false,
                enableColumnMenus: false,
                enableFullRowSelection: true,
                enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
                enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
                enableRowHeaderSelection: false,
                onRegisterApi: function (gridApi) {
                  $scope.upoGrid.api = gridApi;
                },
                columnDefs: [
                  {
                    field: 'entryDate',
                    displayName: 'Date',
                    maxWidth: 100,
                    cellFilter: "date:'MM/dd/yyyy'"
                  },
                  {
                    field: 'poNumber',
                    displayName: 'Number',
                    maxWidth: 80
                  },
                  { field: 'memo', displayName: 'Memo' },
                  {
                    field: 'amountOwed',
                    displayName: 'Remaining',
                    maxWidth: 95,
                    cellFilter: 'currency'
                  }
                ],
                data: resp.data
              };

              /***************************************************************************
               * closePO */
              /**
               * Closes the selected purchase orders and closes the modal dialog
               ***************************************************************************/
              $scope.closePO = function () {
                /*-----------------------------------------------*/
                /* Close selected POs and close the modal dialog */
                /*-----------------------------------------------*/
                BusyScreen.setBusy(true);
                var ids = $scope.upoGrid.api.selection
                  .getSelectedRows()
                  .map(function (po) {
                    return po.id;
                  });

                BooksSvc.closePOs(date, ids).then(function () {
                  BusyScreen.setBusy(false);
                  $uibModalInstance.close();
                });
              };

              /***************************************************************************
               * disableBtn */
              /**
               * Used to disable the Close Selected button when no orders have been selected
               ***************************************************************************/
              $scope.disableBtn = function () {
                return $scope.upoGrid.api.selection.getSelectedCount() < 1;
              };
            }
          })
          .result.finally(function () {
            defer.resolve();
          });

        /**
         * If the dialog is being called from the WriteChecks save process then the BusyScreen will be active
         * when the dialog is pulled up. This was added here to ensure that the BusyScreen is turned off when the
         * dialog is fully opened.
         *
         * Before we had the write checks turn off the BusyScreen before this dialog was opened. This created an issue however
         * where the BusyScreen would be turned off before BooksSvc.getOpenPOsFromDetail had finished processing which is a problem
         * because the dialog is only opened if there is data to display.
         *
         * This UX pattern led to users creating multiple checks because they thought the system was not responding to their request and they would
         * click the button again. This would cause multiple checks to be created. Now we make sure only ot turn off the BusyScreen when the dialog
         * has determined that it has data to display.
         */
        BusyScreen.setBusy(false);
      } else defer.resolve();
    });

    return defer.promise;
  };
}
